import createVueComponent from '../createVueComponent';

const CheckSquare = createVueComponent('CheckSquareIcon', [
  ['polyline', { points: '9 11 12 14 22 4' }],
  ['path', { d: 'M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11' }],
]);

export default CheckSquare;
